<script>
  import { ChevronLeftIcon, ChevronRightIcon } from 'vue-feather-icons';
  export default {
    components: {
      ChevronLeftIcon,
      ChevronRightIcon
    },
    props: {
      pagination: {
        type: Object,
        default: null,
      },
      triggerByMethod: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      fromPage() {
        return (this.pagination.current_page - 1) * this.pagination.per_page + (this.pagination.count ? 1 : 0)
      },
      toPage() {
        return (this.pagination.current_page - 1) * this.pagination.per_page + this.pagination.count
      },
    },
    methods: {
      triggerMethod(page) {
        this.$emit('method', page)
      },
    },
  }
</script>

<template>
  <div v-if="pagination" class="nav-pagination">
    <ul v-if="!triggerByMethod" class="pagination tw-flex align-items-center justify-content-end">
      <li class="tw-whitespace-nowrap">
        {{ fromPage }} - {{ toPage }} <span class="text">of</span> {{ pagination.total }}
      </li>
      <li class="tw-flex">
        <router-link v-if="pagination.current_page > 1" :to="{ query: { ...$route.query, page: pagination.current_page - 1 } }" class="previous tw-ml-6 tw-mr-3">
          <ChevronLeftIcon size="1.5x" class="tw-text-primary"/>
        </router-link>
        <a v-if="pagination.current_page <= 1" class="previous tw-ml-6 tw-mr-3 disabled">
          <ChevronLeftIcon size="1.5x" />
        </a>
        <router-link v-if="pagination.current_page < pagination.total_pages" :to="{ query: { ...$route.query, page: pagination.current_page + 1 } }" class="next tw-ml-3">
          <ChevronRightIcon size="1.5x" class="tw-text-primary" />
        </router-link>
        <a v-if="pagination.current_page >= pagination.total_pages" class="next tw-ml-3 disabled">
          <ChevronRightIcon size="1.5x" />
        </a>
      </li>
    </ul>
    <ul v-else class="pagination tw-flex align-items-center justify-content-end">
      <li>
        {{ fromPage }} - {{ toPage }} <span class="text">of</span> {{ pagination.total }}
      </li>
      <li class="tw-flex">
        <a
          v-if="pagination.current_page > 1"
          class="previous tw-ml-6 tw-mr-3"
          href="javascript:void(0)"
          @click="triggerMethod(pagination.current_page - 1)"
        >
          <ChevronLeftIcon size="1.5x" class="tw-text-primary" />
        </a>
        <a v-if="pagination.current_page <= 1" class="previous tw-ml-6 tw-mr-3 disabled">
          <ChevronLeftIcon size="1.5x" />
        </a>
        <a
          v-if="pagination.current_page < pagination.total_pages"
          class="next tw-ml-3"
          href="javascript:void(0)"
          @click="triggerMethod(pagination.current_page + 1)"
        >
          <ChevronRightIcon size="1.5x" class="tw-text-primary" />
        </a>
        <a v-if="pagination.current_page >= pagination.total_pages" class="next tw-ml-3 disabled">
          <ChevronRightIcon size="1.5x" />
        </a>
      </li>
    </ul>
  </div>
</template>
